module.exports = __webpack_public_path__ + "static/media/who_1.a0baa2f9.png";